import React, { useState, useEffect, useContext, useRef } from "react";
import Table from "../Homepage/Table";
import "../../css_files/Master/CustomerMaster.css";
import AddCustomerMaster from "./AddCustomerMaster";
import SearchCustomerMaster from "./SearchCustomerMaster";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import MoreCustomerMasterDetails from "./MoreCustomerMasterDetails";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function CustomerMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Name", "Code", "Description", "GST Number", ""];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [customerupdatedata, setcustomerupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [showmorecustomerdata, setshowmorecustomerdata] = useState(false);
  const [moredetailsloading, setmoredetailsloading] = useState(false);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [totalcount, setTotalCount] = useState(0);
  const [customerId, setcustomerId] = useState(null);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);

  async function fetchcustomerdata(customerid, show = false) {
    setmoredetailsloading(true);
    try {
      const customerdata = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/api/v1/Customer/GetCustomerByIdOrName?id=${customerid}&page=1`
      );
      setcustomerupdatedata(customerdata.data.data[0]);
      setshowmorecustomerdata(show);
      setmoredetailsloading(false);
    } catch (error) {
      console.error("Unexpected error fetching customer data:", error);
      setmoredetailsloading(false);
    }
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Customer/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: customerId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.orgName,
            x.pricing.code,
            x.description,
            x.gstNumber,
            "Tap here to See More Details",
          ])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Customer" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Customer" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Customer" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Customer" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="customer-master">
      <h1>Customer Master</h1>
      <blockquote className="customer-master-forms">
        <AddMaster
          text="Add Customer Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Customer Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddCustomerMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          customerupdatedata={customerupdatedata}
          key={`${customerupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchCustomerMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setCustomerId={setcustomerId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchcustomerdata}
        url="Customer/UpdateCustomerCommand"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
      {showmorecustomerdata && (
        <MoreCustomerMasterDetails
          setshowmorecustomerdata={setshowmorecustomerdata}
          customerupdatedata={customerupdatedata}
          loading={moredetailsloading}
        />
      )}
    </section>
  );
}

export default CustomerMaster;
